import { alpha, Box, Button, Menu, MenuItem, styled } from "@mui/material";
import React, { useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import styles from "../../../styles/styles";
import Document from "../../../components/LawyerCompo/Document/Document";
import FolderView from "../../../components/LawyerCompo/Document/FolderView";
import { useLocation } from "react-router-dom";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { useDialog } from "../../../components/DialogContext";
import CreateFolderForm from "../../../components/LawyerCompo/Document/CreateFolderForm";
import CreateDocWithTempForm from "../../../components/LawyerCompo/Document/CreateDocWithTempForm";
import UploadFileForm from "../../../components/LawyerCompo/Document/UploadFileForm";
import UploadFolderForm from "../../../components/LawyerCompo/Document/UploadFolderForm";

export const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

const DocumentPage = () => {
  const { showDialog } = useDialog();
  const [anchorEl, setAnchorEl] = useState(null);
  const location = useLocation();

  const isFolderView = location.pathname.startsWith(
    "/dashboard/documents/folder/"
  );

  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const { control, handleSubmit, setValue } = useForm({
    defaultValues: {
      files: null,
      folder: null,
    },
  });

  const onSubmit = (data) => {
    if (data.files) {
      console.log("Uploaded Files:", data.files);
      // Array.from(data.files).forEach((file) => {
      //   console.log(
      //     `File: ${file.name}, Size: ${file.size} bytes, Type: ${file.type}`
      //   );
      // });
      showDialog(<UploadFileForm fileData={data?.files} />, {
        dialogTitle: "Upload File",
      });
    }
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <div className="flex justify-between bg-white rounded-lg items-center shadow-md p-2">
            <h2 className={`${styles.title}`}>Documents</h2>
            <Box className="flex gap-4">
              <Button
                id="demo-customized-button"
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownRoundedIcon />}
                size="small"
              >
                New Document
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <Controller
                  name="files"
                  control={control}
                  render={({ field: { onChange } }) => (
                    <input
                      type="file"
                      multiple
                      style={{ display: "none" }}
                      onChange={(e) => {
                        onChange(e.target.files);
                        handleClose();
                        handleSubmit(onSubmit)();
                      }}
                    />
                  )}
                />
                <MenuItem
                  onClick={() => {
                    const fileInput = document.querySelector(
                      'input[type="file"][multiple]'
                    );
                    if (fileInput) fileInput.click();
                  }}
                  disableRipple
                >
                  Upload files
                </MenuItem>

                <Controller
                  name="folder"
                  control={control}
                  render={({ field: { onChange } }) => (
                    <input
                      type="file"
                      webkitdirectory="true"
                      directory="true"
                      style={{ display: "none" }}
                      onChange={(e) => {
                        const files = e.target.files;
                        if (files.length > 0) {
                          const firstFilePath = files[0].webkitRelativePath;
                          const folderName = firstFilePath.split("/")[0];
                          showDialog(
                            <UploadFolderForm
                              folderData={{ name: folderName, files }}
                            />,
                            {
                              dialogTitle: `Upload Folder - ${folderName}`,
                            }
                          );
                        }

                        handleClose();
                      }}
                    />
                  )}
                />
                <MenuItem
                  onClick={() => {
                    const folderInput = document.querySelector(
                      'input[type="file"][webkitdirectory]'
                    );
                    if (folderInput) folderInput.click();
                  }}
                  disableRipple
                >
                  Upload folder
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    handleClose();
                    showDialog(<CreateFolderForm />, {
                      dialogTitle: "Create Folder",
                    });
                  }}
                  disableRipple
                >
                  Create folder
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleClose();
                    showDialog(<CreateDocWithTempForm />, {
                      dialogTitle: "Create Document ",
                    });
                  }}
                  disableRipple
                >
                  Create document from template
                </MenuItem>
              </StyledMenu>
            </Box>
          </div>
          <div className="flex items-start justify-between w-full">
            {isFolderView ? <FolderView /> : <Document />}
          </div>
        </Box>
      </Box>
    </>
  );
};

export default DocumentPage;
